export default "__VITE_ASSET__8e272314__"